import script from "./VisitModalAdditionallyPartNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitModalAdditionallyPartNew.vue?vue&type=script&setup=true&lang=js"

import "./VisitModalAdditionallyPartNew.vue?vue&type=style&index=0&id=4d631856&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d631856"]])

export default __exports__